import axios, { AxiosRequestConfig } from 'axios'
import { Credentials, IEthCurrency, WalletDetailsParams } from './model'

const NFTBANK_KEY = 'f0c7542609e6e54550873429012d54f3'
const ApiTokenEtherscan = 'QYS7AQ3CMERQD327M9NHBHMV53WKWEAXT5'
const development = process.env.REACT_APP_ENVIRONMENT === 'development'
const BASE_URL = development ? 'http://localhost:3001/api' : process.env.REACT_APP_NETTYWORTH_API

const axiosInstance = axios.create({
  baseURL: BASE_URL,
})

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.withCredentials = true
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config
    const permissionError = error?.response?.data?.includes?.('role')

    if (error.response.status === 403 && !permissionError && !originalRequest._retry) {
      localStorage.removeItem('token')
    }
    return Promise.reject(error)
  },
)

export const apiRequest = async (
  url: string,
  method = 'GET',
  body?: object,
  withToken = true,
  customConfigs = {},
) => {
  const config: AxiosRequestConfig = {
    method,
    url,
    data: body,
    ...customConfigs,
  }

  try {
    const { data } = await axiosInstance(config)
    return data
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const loginUser = async (credentials: Credentials) => {
  return apiRequest('/auth', 'POST', credentials, false)
}

export const verifyLogin = async (body: { token: string }) => {
  return apiRequest('/auth/verify-login', 'POST', body, false)
}

export const registerWithDynamic = async (body: {
  email: string
  token: string
}): Promise<{ message: 'exist' | 'created' }> => {
  const res = await apiRequest('/users/dynamic-register', 'POST', body, false, {
    withCredentials: true,
  })
  return res
}

export const loginAdmin = async (body: { email: string; token: string }) => {
  return apiRequest('/users/admin-login', 'POST', body, false)
}

export const refreshToken = async () => {
  const { accessToken } = await apiRequest('/refresh', 'GET', undefined, true, {
    withCredentials: true,
  })
  localStorage.setItem('token', accessToken)
}

export const logoutUser = async () => {
  return apiRequest('/logout')
}

export const getWalletCount = async (params?: WalletDetailsParams) => {
  return apiRequest('/eth/wallets/count', 'GET', undefined, true, { params })
}

export const getWalletDetails = async (params?: WalletDetailsParams) => {
  return apiRequest('/eth/wallets', 'GET', undefined, true, { params })
}

export const getUserInventory = async (ownerAddress: string) => {
  return axios.get(`https://api.nftbank.ai/estimates-v2/user-inventory/ethereum/${ownerAddress}`, {
    headers: {
      'X-API-KEY': NFTBANK_KEY,
      'Content-Type': 'application/json',
    },
  })
}

export const getEthCurrency = async (): Promise<IEthCurrency> => {
  return axios
    .get(`https://api.etherscan.io/api?module=stats&action=ethprice&apikey=${ApiTokenEtherscan}`)
    .then((res) => res.data.result)
}
